import { render, staticRenderFns } from "./Hoops5x5Challenge.vue?vue&type=template&id=3c47b471"
import script from "./Hoops5x5Challenge.vue?vue&type=script&lang=js"
export * from "./Hoops5x5Challenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports